"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var StoreEntity_1 = __importDefault(require("../../Core/StoreEntity"));
var Alerts_consts_1 = require("../Alerts.consts");
// Some adjustments to StoreEntity logic is required if proxying through store is required
var AlertsEntity = /** @class */ (function (_super) {
    __extends(AlertsEntity, _super);
    function AlertsEntity(session) {
        var _this = _super.call(this, {
            session: session,
            entityName: 'alerts'
            // Those are used for internal store logic, not applicable to alerts at the moment
            // check StoreEntity -> Entity -> CrudService for more detail
            // potentially can be used for alerts if:
            // 1) id - uuid conflict is resolved: methods expect to use entity.id as identifier
            // but alert.uuid is used for alerts
            // 2) alerts api complies to url rules, check CrudService for the rules
            // routes: [BaseRoutes.GetAll, BaseRoutes.Delete]
        }) || this;
        _this.isSubscriptionsAttached = false;
        _this._onUpdateOwnership = [];
        _this.onUpdateOwnership = function (entity) {
            _this._onUpdateOwnership.forEach(function (fn) { return fn(entity); });
        };
        _this.registerOnUpdateOwnership = function (fn) {
            _this._onUpdateOwnership.push(fn);
            return function () { return _this._onUpdateOwnership.splice(_this._onUpdateOwnership.indexOf(fn), 1); };
        };
        return _this;
    }
    AlertsEntity.prototype.attachSubscriptions = function () {
        if (!this.isSubscriptionsAttached) {
            this.realTime.on(Alerts_consts_1.AlertRealTimeEvents.CREATED, this.onCreate);
            this.realTime.on(Alerts_consts_1.AlertRealTimeEvents.DELETED, this.onDelete);
            this.realTime.on(Alerts_consts_1.AlertRealTimeEvents.UPDATED_OWNERSHIP, this.onUpdateOwnership);
            this.isSubscriptionsAttached = true;
        }
    };
    AlertsEntity.prototype.getAlertsKeySetPagination = function (queryParams) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .get(Alerts_consts_1.Routes.GET_ALL)
                            .withQueryString(queryParams)
                            .setException('failed to get alerts')
                            .withExtractor(Alerts_consts_1.alertsExtractor)
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AlertsEntity.prototype.dismiss = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .delete(Alerts_consts_1.Routes.DISMISS)
                            .withRouteParams({ uuid: uuid })
                            .setException("failed to dismiss alert ".concat(uuid))
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AlertsEntity.prototype.batchDismiss = function (uuids) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .post(Alerts_consts_1.Routes.BATCH_DISMISS)
                            .withPayload({ ids: uuids })
                            .setException("failed to dismiss alerts ".concat(uuids.toString()))
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AlertsEntity.prototype.updateOwnership = function (params) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .post(Alerts_consts_1.Routes.UPDATE_OWNERSHIP)
                            .withPayload(params)
                            .setException("failed to update alerts ownership ".concat((_a = params === null || params === void 0 ? void 0 : params.alertUuids) === null || _a === void 0 ? void 0 : _a.join(', ')))
                            .invoke()];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    return AlertsEntity;
}(StoreEntity_1.default));
exports.default = AlertsEntity;
//# sourceMappingURL=AlertsEntity.js.map